import {createStyles} from '../../../lib/style';
import { colors } from '../../../styles/colors';

export const styles = createStyles(() => ({
        root: {
            flex: 1,
            //position: 'relative',
            backgroundColor: '#FFFFFF',
        },
        template: {
            flex: 1,
            paddingTop: '5%',
            paddingBottom: '5%',
            alignItems: 'stretch',
            backgroundColor: '#FFFFFF',
            justifyContent: 'space-between',
        },
        satisfaction: {
            marginTop: 34,
            marginBottom: 35,
        },
        loadingContainer: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 50,
        },
        loading: {
            backgroundColor: 'transparent',
        },
        headerPayment: {
            paddingBottom: 20,
            //height: 80,
            justifyContent: 'flex-end',
        },
        infoBox: {
            shadowColor: 'gray',
            shadowOffset: {
                width: 3,
                height: 3
            },
            shadowOpacity: 0.5,
            shadowRadius: 2,

            errorRoot: {
                top: -30,
            },
        },
        input: {
            backgroundColor: '#F6F6F6',
            borderColor: '#E8E8E8',
            borderWidth: 1.5,
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 'bold',
            lineHeight: 18,
            paddingLeft: 20,
            height: 50,
            color: '#000000',
        },
        titleEmail: {
            marginTop: 14,
            padding: 10,
            paddingLeft: 5,
            textAlign: 'start',
            fontSize: 12,
            lineHeight: 14,
            color: colors.Gray_1,
        },
        titleDetail: {
            marginTop: 14,
            padding: 10,
            paddingLeft: 5,
            textAlign: 'start',
            fontSize: 12,
            lineHeight: 14,
            color: colors.Gray_1,
        },
    }
));
